import React from "react";
import Resume from "./Resume";
import InformationSection from "./InformationSection";

const Body = () => {
  return (
    <div className="flex flex-col h-screen bg-center bg-no-repeat bg-cover bg-gradient-to-r from-indigo-900 to-indigo-700">
      <div className="flex flex-col h-full md:flex-row md:justify-center md:items-center md:mt-4">
        <div className="flex justify-center items-center md:w-1/2">
          <img className="mt-5 rounded-full bg-zinc-950 w-48 md:w-64 lg:w-80" src="/profile-pic.png" alt="I" />
        </div>
        <div className="flex flex-col justify-center w-full md:w-1/2 px-6 py-12 md:py-0">
          <div className="font-mono text-xl text-gray-800">
            <InformationSection />
            <Resume />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
